export default {"src":"/_next/static/media/step1.cdd3958b.svg","height":68,"width":58};